import theme from '../../theme';

// Thin compatibility shim -- delegates to theme.js (the real single source
// of truth) instead of the old, disagreeing CSS-keyword palette, so every
// existing `getIndicatorColor(label)` call site keeps working unchanged.
const LABEL_TO_TOKEN = {
  SMA: () => theme.indicators.sma,
  EMA: () => theme.indicators.ema,
  'Bollinger-Bands': () => theme.indicators.bollinger.middle,
  MACD: () => theme.indicators.macd.line,
  RSI: () => theme.indicators.rsi.line,
  'Stochastic-Oscillator': () => theme.indicators.stochastic.k,
  ADX: () => theme.indicators.adx,
  OBV: () => theme.indicators.obv,
  CMF: () => theme.indicators.cmf,
  CCI: () => theme.indicators.cci,
  'Williams-R': () => theme.indicators.williamsR,
  AROON: () => theme.indicators.aroon.up,
  MFI: () => theme.indicators.mfi,
  ROC: () => theme.indicators.roc,
  CMO: () => theme.indicators.cmo,
  RVI: () => theme.indicators.rvi.line,
  'Elder-Ray': () => theme.indicators.elderRay.bull,
  ATR: () => theme.indicators.atr,
};

export const getIndicatorColor = (indicator) => {
  const resolver = LABEL_TO_TOKEN[indicator];
  return resolver ? resolver() : theme.brand.indigo;
};
